<template>
  <div id="contenedor-eliminar-evento-licitacion">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Evento </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el Evento "{{eventoLicitacionEliminar.eventoTexto}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarEvento"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixLicitacionEventos from './mixLicitacionEventos';

export default {
  name: 'EliminarEventoLicitacion',
  mixins: [mixLicitacionEventos],
  props: {
    eventoLicitacionEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
